/* eslint-disable no-console */
/* eslint-disable no-param-reassign */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import Axios from 'axios';

const JSON_CONTENT_TYPE = 'application/json';

let SETTINGS;

/**
 * Object that defines based on a path param (in request) provides the asociated
 * transaction code needed in the token
 */
const TRANSACTION_FOR_CALL = {
  products: 'T18000',
  'simple-accounts': 'T18000',
  kyc: 'TRXAML',
};

/**
 * Search for a settings.json to set the bff url and the jwt provider
 * @access private
 */
const getSettingsConfig = async () => {
  const response = await Axios.get('/mfe-home-web-cl/settings.json', {
    headers: {
      'content-type': JSON_CONTENT_TYPE,
    },
  });
  SETTINGS = response.data;
};

export const getAvatarRendererUrl = async () => {
  if (!SETTINGS) {
    await getSettingsConfig();
  }

  return SETTINGS.avatarRendererUrl;
};

export const getHomeScotiaLevelsUrl = async () => {
  if (!SETTINGS) {
    await getSettingsConfig();
  }

  return SETTINGS.homeScotiaLevelsUrl;
};

export const getScotiawebMenuRendererUrl = async () => {
  if (!SETTINGS) {
    await getSettingsConfig();
  }

  return SETTINGS.scotiawebMenuRendererUrl;
};

/**
 * get the bff url
 * @access public
 */
export const bffUrl = async () => {
  if (!SETTINGS) {
    await getSettingsConfig();
  }
  return `${SETTINGS.apiBaseUrl}bff-home-web-cl/`;
};

/**
 * url for pending activities
 * @access public
 */
export const pendingActivitiesApiUrl = async () => {
  if (!SETTINGS) await getSettingsConfig();

  return `${SETTINGS.pendingActivitiesApiUrl}`;
};

export const gtmId = async () => {
  if (!SETTINGS) {
    await getSettingsConfig();
  }
  return SETTINGS.gtmId;
};

/**
 * get the jwt url
 * @access public
 */
export const jwtUrl = async () => {
  if (!SETTINGS) {
    await getSettingsConfig();
  }

  return `${SETTINGS.jwtProviderUrl || ''}/cgi-bin/transac/dotrxajax`;
};

export const getKycUrl = async () => {
  if (!SETTINGS) {
    await getSettingsConfig();
  }
  return SETTINGS.kycUrl || '/';
};

export const campaignProviderUrl = async () => {
  if (!SETTINGS) {
    await getSettingsConfig();
  }
  return SETTINGS.campaignProviderUrl || '/';
};

export const getOnlineCurseInfoProvider = async () => {
  if (!SETTINGS) {
    await getSettingsConfig();
  }
  return `${SETTINGS.onlineCourseInfoProviderHost || SETTINGS.apiBaseUrl}bff-onlinecourse-web-cl/api/messageHome`;
};

export const getMercurySettings = async () => {
  if (!SETTINGS) {
    await getSettingsConfig();
  }
  return {
    mercuryApiUrl: SETTINGS.mercuryApiUrl,
    mercuryRenderersUrl: SETTINGS.mercuryRenderersUrl,
  };
};

export const getToken = async config => {
  const url = await jwtUrl();
  let tokenIntends = '';
  if (config.tokenIntends === undefined) {
    Object.keys(TRANSACTION_FOR_CALL).forEach(key => {
      if (config.url.includes(key)) {
        tokenIntends = TRANSACTION_FOR_CALL[key];
      }
    });
  } else {
    tokenIntends = config.tokenIntends;
  }

  return new Promise((resolve, reject) => {
    Axios.get(url, {
      params: {
        TMPL: '/security/jwt.xml',
        intends: tokenIntends.toString(),
      },
    })
      .then(response => {
        resolve(response.data.token);
      })
      .catch(error => {
        reject(error);
      });
  });
};
/*
 * @param {String} token The token to be decoded
 */
const decodeJwt = token => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(c => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
};

/**
 * calls mopa to get the clients rut based on token
 */
export const getClientRut = async () => {
  const token = await getToken({
    tokenIntends: '',
  });
  return decodeJwt(token).sub;
};

const instance = Axios.create({
  timeout: 30000,
  headers: {
    'Content-Type': JSON_CONTENT_TYPE,
  },
});

instance.interceptors.request.use(
  config =>
    getToken(config)
      .then(tokenResponse => {
        config.headers.Authorization = `Bearer ${tokenResponse}`;
        return Promise.resolve(config);
      })
      .catch(error => {
        console.log(error);
      }),
  error => Promise.reject(error)
);

export const instanceClean = Axios.create({
  timeout: 30000,
});

export default instance;
